export default (target) => String(target).padStart(2, '0');
